import React, { useCallback, useMemo, useState } from 'react';
import ReleaseFileLoadingContext from './ReleaseFileLoading.context';

type ReleaseFileLoadingProviderProps = {
  children: React.ReactNode;
};

const ReleaseFileLoadingProvider: React.FC<ReleaseFileLoadingProviderProps> = ({
  children,
}) => {
  const [loadingByLeadId, setLoadingByLeadId] = useState<
    Record<string, Record<string, boolean>>
  >({});

  const isReleaseFileLoadingForLead = useCallback(
    (leadId: string, dataRoomNodeId: string) =>
      !!loadingByLeadId[leadId]?.[dataRoomNodeId],
    [loadingByLeadId],
  );

  const setReleaseFileLoadingForLead = useCallback(
    (leadId: string, dataRoomNodeId: string, loading: boolean) => {
      setLoadingByLeadId((prev) => {
        const prevLeadMap = prev[leadId] || {};

        if (prevLeadMap[dataRoomNodeId] === loading) return prev;

        return {
          ...prev,
          [leadId]: { ...prevLeadMap, [dataRoomNodeId]: loading },
        };
      });
    },
    [],
  );

  const value = useMemo(
    () => ({
      isReleaseFileLoadingForLead,
      setReleaseFileLoadingForLead,
    }),
    [isReleaseFileLoadingForLead, setReleaseFileLoadingForLead],
  );

  return (
    <ReleaseFileLoadingContext.Provider value={value}>
      {children}
    </ReleaseFileLoadingContext.Provider>
  );
};

export default ReleaseFileLoadingProvider;
